import type {
  EventDescriptionPartModel,
  TextDescriptionModel,
  MentionModel,
} from 'shared/domain/issue/issueModel';

export enum EventDescriptionType {
  text = 'text',
  mention = 'mention',
}

export function isTextDescriptionPart(
  part: EventDescriptionPartModel
): part is TextDescriptionModel {
  return part.type === EventDescriptionType.text;
}

export function isMentionDescriptionPart(
  part: EventDescriptionPartModel
): part is MentionModel {
  return part.type === EventDescriptionType.mention;
}
